export const sessionStorageService = {
  get: getFromSession,
  set: setToSession,
  remove: removeFromSession,
  cacheData: cacheDataToSession,
  getCachedData: getCachedDataFromSession,
}

function getFromSession(key) {
  const rawData = sessionStorage.getItem(key)
  if (!rawData) return null
  return JSON.parse(rawData)
}

function setToSession(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value))
}

function removeFromSession(key) {
  sessionStorage.removeItem(key)
}

function cacheDataToSession(storageKey, data, expirationTime = 30 * 60 * 1000) {
  setToSession(storageKey, {
    data,
    expirationTime: Date.now() + expirationTime,
  })
}

function getCachedDataFromSession(storageKey) {
  const cachedData = getFromSession(storageKey) || {}
  if (cachedData?.data && isCacheValid(cachedData?.expirationTime)) {
    return cachedData.data
  } else return null
}

function isCacheValid(cacheTimestamp) {
  return !!(Date.now() <= cacheTimestamp)
}
